export enum RailwayStationTab {
  Resident,
  Work
}
